import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { installDialogOverrides } from '@/lib/dialogs'

// Replace native alert/confirm with styled in-app dialogs (call once at boot)
installDialogOverrides()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
